// extracted by mini-css-extract-plugin
module.exports = {"pageNavLink":"PageNavigationLink_pageNavLink__XuIqz","linkText":"PageNavigationLink_linkText__nuYDG"};